import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionId } from '../model/index.tsx';
import type { UnresolvedIssuesCount, Version as RestVersion } from './types.tsx';

export const getVersionEndpointUrl = (baseUrl: string, versionId: VersionId): string =>
	`${baseUrl}/rest/api/2/version/${versionId}`;

export const getVersionWithIssuesUrl = (baseUrl: string, versionId: VersionId): string =>
	`${getVersionEndpointUrl(baseUrl, versionId)}?expand=issuesstatus`;

export const getUnresolvedIssuesInVersionUrl = (baseUrl: string, versionId: VersionId): string =>
	`${getVersionEndpointUrl(baseUrl, versionId)}/unresolvedIssueCount`;

export const getVersion = (baseUrl: string, versionId: VersionId): Promise<RestVersion> =>
	fetchJson(getVersionWithIssuesUrl(baseUrl, versionId));

export const getUnresolvedIssuesCount = (
	baseUrl: string,
	versionId: VersionId,
): Promise<UnresolvedIssuesCount> => fetchJson(getUnresolvedIssuesInVersionUrl(baseUrl, versionId));
